import {toast} from 'react-toastify'

const handleError = (error: any) => {
  let dataErr = {}
  let setMessage = ''
  let setStep = ''
  const {response, message} = error
  const status = response ? response.status : null
  try {
    setMessage = response?.data?.data?.message || message
    setStep = response?.data?.data?.step || ''
  } catch (e) {
  }
  switch (status) {
    case 400:
      dataErr = {
        code: response.status,
        message: setMessage,
        desc: 'Bad Request',
      }
      const mssg = response.data?.meta?.message
      const error = response.data?.meta?.error

      if (error) {
        Object.keys(error).forEach(function (key, index) {
          setTimeout(
            () => {
              toast.error(error[key][0])
            },
            index === 0 ? 0 : 200
          )
        })
      } else {
        toast.error(mssg)
      }

      dataErr = {
        code: 303,
        message: mssg,
        desc: message,
        error: response?.data?.meta?.error,
      }
      break
    case 401:
      dataErr = {
        code: response.status,
        message: setMessage,
        desc: 'Unauthorized',
      }

      if (!localStorage.getItem('is_expired')) {
        toast.error('Token expired atau akun sedang digunakan pada perangkat lain.', {
          autoClose: 5000,
        })
      }

      localStorage.setItem('is_expired', 'true')
      setTimeout(() => {
        localStorage.clear()
        window.location.href = '/auth/login'
      }, 5000)

      break
    case 402:
      dataErr = {
        code: response.status,
        message: setMessage,
        desc: 'Payment Required',
      }
      break
    case 403:
      dataErr = {
        code: response.status,
        message: setMessage,
        desc: 'Forbidden',
      }
      
      toast.error(response.data?.meta?.message)
      break
    case 404:
      dataErr = {
        code: response.status,
        message: setMessage,
        desc: 'Not Found',
      }
      break
    case 409:
      dataErr = {
        code: response.status,
        message: setMessage,
        desc: 'Conflict',
      }
      break
    case 422:
      dataErr = {
        code: response.status,
        message: setMessage,
        desc: response.data.response.message,
        step: setStep,
      }
      break
    case 500:
      toast.error(response.data?.meta?.message || 'Ada kesalahan di server.')
      dataErr = {
        code: response.status,
        message: setMessage,
        custom: response?.data,
        desc: 'Internal Server Error',
      }
      break
    default:
      dataErr = {
        code: 303,
        message: setMessage,
        desc: message,
        error: response?.data?.meta?.error,
      }
      break
  }
  return dataErr
}

export default handleError
